import { OrganizationOutput } from 'organization/model/organization.output';
import { Organization } from 'organization/organization';

export abstract class OrganizationConverterPort {
	public abstract organizationAsEntity(output: OrganizationOutput): Organization;

	public abstract organizationsAsEntities(
		outputs: OrganizationOutput[]
	): Organization[];
}
